module.exports = __webpack_public_path__ + "static/img/edit.417f6590.svg";